import { useRouteLoaderData } from 'react-router'
import { type loader as rootLoader } from '#app/root.tsx'

const TUNI_AUTH_METHOD = 'tuni'

export function useTuniAuthMode() {
  const data = useRouteLoaderData<typeof rootLoader>('root')

  return data?.ENV.USE_TUNI_AUTH
}

export function useSessionAuthMethod() {
  const data = useRouteLoaderData<typeof rootLoader>('root')

  return data?.authMethod ?? null
}

export function useTuniAuthStrict() {
  return useTuniAuthMode() === 'true'
}

export function useSessionUsesTuniAuth() {
  return useSessionAuthMethod() === TUNI_AUTH_METHOD
}
